function pad2(value) {
  return String(value).padStart(2, "0")
}

/**
 * Formats an ISO8601 timestamp in the browser's local timezone.
 * Matches Rails I18n time.formats.short / time.formats.dynamics.
 *
 * @param {string|null|undefined} isoString
 * @param {string|null|undefined} locale
 * @param {string} [format] "short" | "dynamics"
 * @returns {string}
 */
export function formatLocalDateTime(isoString, locale, format = "short") {
  if (!isoString) return ""

  const date = new Date(isoString)
  if (Number.isNaN(date.getTime())) return ""

  const year = date.getFullYear()
  const month = pad2(date.getMonth() + 1)
  const day = pad2(date.getDate())
  const hours = pad2(date.getHours())
  const minutes = pad2(date.getMinutes())

  if (locale === "en") {
    return `${year}-${month}-${day} ${hours}:${minutes}`
  }

  // ru and default: same pattern for short and dynamics
  return `${day}.${month}.${year} ${hours}:${minutes}`
}

/** @deprecated Use formatLocalDateTime — kept for test_dynamics_controller */
export function formatDynamicsDateTime(isoString, locale) {
  return formatLocalDateTime(isoString, locale, "dynamics")
}
